<template>
  <div class="multi-main wrapper modal-confirm-email" @click.stop.prevent="hideConfirmBox">
    <div class="multi-select wrapper" @click.stop.prevent>
      <div class="modal-header">
        <h4>Confirm Email</h4>
      </div>
      <div class="modal-content">
        <p class="title-first" v-html="mailContactText"></p>
      </div>
      <div class="modal-ctas">
        <button @click="sendEmail" class="buttonstyle">Send</button>
        <button @click.stop.prevent="hideConfirmBox" class="buttonstyle">Cancel</button>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MailContactConfirm",
    data() {
      return {
      };
    },
    props: {
      hideConfirmBox: Function,
      mailContactText: String,
      sendEmail: Function
    }
  };
</script>

<style scoped>
  .multi-main.wrapper {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .multi-main.wrapper:hover {
    cursor: default;
  }

  .multi-select.wrapper {
    padding: 5% 5% 5% 5%;
    background-color: white;
    flex-flow: column;
    max-height: 70vh;
    overflow-y: auto;
  }

  .multi-select .title {
    font-size: 20px;
    margin-top: 20px;
    margin-bottom: 5px;
  }

  .multi-select .title-first {
    font-size: 20px;
    margin-bottom: 5px;
  }

  .multi-select.option {
    padding: 2%;
    border-bottom: 1px solid #eeeded;
    font-size: 16px;
    transition: all 0.2s ease-in-out;
  }

  .multi-select.option:hover {
    background-color: #eeeded;
  }

  .multi-select.option {
    display: flex;
  }

  .multi-select.option:hover {
    cursor: pointer;
  }

  .multi-select.check {
    width: 5px;
    height: 5px;
    margin-right: 10px;
    position: relative;
    top: 7px;
  }

  .multi-select.selected {
    border-radius: 10px;
    background-color: #5888c5;
  }

  #add-contact-l2 .multi-select.wrapper {
    padding: 10px 20px;
    border-radius: 5px;
    margin-top: 100px;
    overflow-y: auto;
  }

  #add-contact-l2 .multi-select.wrapper h2 {
    color: #d26d13;
    margin: 5px 0 25px 0;
    font-weight: bold;
    font-size: 18px;
    padding-top: 5px;
    border-bottom: none;
  }

  #add-contact-l2 .multi-select .title {
    border-bottom: 1px solid #ebebeb;
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    margin-bottom: 0px;
    position: relative;
    color: #444;
    margin-top: 10px;
  }

  #add-contact-l2 .multi-select .title a.icon-accordion-down,
  #add-contact-l2 .multi-select .title a.icon-accordion-up {
    position: absolute;
    right: 0;
    top: 0;
    width: 16px;
    height: 16px;
  }

  #add-contact-l2 .multi-options.wrapper {
    overflow-y: auto;
    max-height: 170px;
    margin-bottom: 0;
    margin-right: 5px;
    margin-top: 5px;
    width: 100%;
  }
  #add-contact-l2 .multi-select.option {
    line-height: 24px;
    font-size: 14px;
    border-bottom: 1px solid #f6f6f6;
    width: 90%;
  }
  #add-contact-l2 .multi-select.check {
    width: 10px;
    height: 10px;
  }
  .multi-options.wrapper {
    transition: all 0.2s ease-in-out;
  }

  .hide-section {
    max-height: 0px !important;
  }

  img {
    transition: all 0.3s ease-in-out;
  }

  .rotate {
    transform: rotate(180deg);
  }
  .multi-main.wrapper.modal-confirm-email{
z-index:99999999;
}
.modal-confirm-email .multi-select.wrapper{
max-width:400px;
display:flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    margin-left:20px;
    margin-right: 20px;
    padding:0;
}
.modal-confirm-email .modal-header{
  background:#000;
  color:#fff;
  font-size:16px;
  font-weight: bold;
  width:100%;
}
.modal-confirm-email .modal-header h4{
  font-size:16px;
  font-weight: bold;
  margin:10px auto 10px 15px;
}
.modal-confirm-email .modal-content{
  padding:15px;
}
.modal-confirm-email .modal-content p{
  font-size:14px;
  line-height:24px;
  padding:15px;
}
.modal-confirm-email .modal-ctas{
 display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    align-content: flex-end;
    width: 100%;
    padding: 0;
    margin: 0 40px 20px 0;
}
.modal-confirm-email .buttonstyle{
  border:none;
  float: none;
}
</style>
